import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  dark = false
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-65" data-mp="3f2n5jtmhckow">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.16em] sm:text-sm ${dark ? "text-cta" : "text-brand"}`} data-id="element-66" data-mp="3jzdocopo5ue0">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-display text-[30px] font-extrabold leading-[1.1] tracking-tight sm:text-5xl ${dark ? "text-white" : "text-ink"}`} data-id="element-67" data-mp="bmpw5mw57grm">
        {title}
      </h2>
      {intro && <p className={`mt-4 text-lg leading-relaxed sm:text-xl ${dark ? "text-white/80" : "text-muted"}`} data-id="element-68" data-mp="6t52g71l18y8">{intro}</p>}
    </div>;
}